<ng-container *ngIf="!introScreen; else intro">
  <kp-modal
    *ngIf="eulaContent && privacyContent && isEulaOpen"
    [(isOpen)]="isEulaOpen"
    [html]="eulaContent"
    type="legal"></kp-modal>
  <div *ngIf="privacyContent" class="content content-privacy" [innerHTML]="parsedPrivacyHtml | sanitizeHtml"></div>
  <div
    *ngIf="eulaContent && !privacyContent"
    class="content content-eula"
    [innerHTML]="parsedEulaHtml | sanitizeHtml"></div>

  <div class="controls" *ngIf="(privacyContent || eulaContent) && showAcceptanceControls">
    <div class="checkbox-acceptance-container">
      <kp-checkbox *ngIf="privacyContent" [isChecked]="privacyAccepted" (check)="privacyCheckbox($event)">
        I accept the privacy policy
      </kp-checkbox>
      <kp-checkbox *ngIf="eulaContent" [isChecked]="eulaAccepted" (check)="eulaCheckbox($event)">
        <span *ngIf="eulaContent && privacyContent">
          I accept the
          <a class="eula-title" (click)="openEula($event)" href="#">Acceptable Use Policy</a>
        </span>
        <span *ngIf="eulaContent && !privacyContent">I accept the acceptable use policy</span>
      </kp-checkbox>
    </div>

    <div class="buttons-container">
      <button
        class="button button-pill button-reverse button-continue"
        [disabled]="isButtonDisabled"
        type="submit"
        (click)="continue()">
        Continue
      </button>
    </div>
  </div>
</ng-container>

<ng-template #intro>
  <kp-intro-screen (closeIntro)="introScreen = false">
    <ng-container *ngIf="eulaContent && privacyContent">
      We've updated our Privacy Policy and Acceptable Use Policy.
    </ng-container>
    <ng-container *ngIf="eulaContent && !privacyContent">We've updated our Acceptable Use Policy.</ng-container>
    <ng-container *ngIf="this.privacyContent && !this.eulaContent">We've updated our Privacy Policy.</ng-container>
  </kp-intro-screen>
</ng-template>
